import { useDispatch } from 'react-redux';
import { useHomeSlice } from 'app/pages/Home/slice';
import { saveUserPreferences } from 'utils/helpers';

/**
 * Custom hook to clear Must Win dropdown special UI state
 *
 * This hook provides a function that:
 * - Clears the blue highlight from Must Win dropdown
 * - Shows all swimlanes (stops hiding empty ones)
 * - Persists these changes to localStorage
 *
 * Usage:
 * ```typescript
 * const clearMustWinState = useClearMustWinState();
 *
 * // In any filter handler:
 * clearMustWinState();
 * ```
 *
 * @returns A function that clears Must Win dropdown state
 */
export function useClearMustWinState() {
  const { actions } = useHomeSlice();
  const dispatch = useDispatch();

  const clearMustWinState = () => {
    dispatch(actions.setMustWinDropdownSelection(null));
    dispatch(actions.setHideEmptySwimLanes(false));
    saveUserPreferences({
      mustWinDropdownSelection: null,
      hideEmptySwimLanes: false
    });
  };

  return clearMustWinState;
}
